import ScrollMagic from "scrollmagic";
import $ from "jquery";

// not sure if i should put the time in to delete all the scenes and remake on window resize...

var pin = document.querySelector(".column--side .widget_nav_menu");
var $main = $(".column--main");
var controller = new ScrollMagic.Controller();

var side_menu = $(".side-menu");

var anchors = side_menu.find("a");

anchors.each(function() {
  var href = $(this)
    .attr("href")
    .indexOf("#");
  if (href === 0) {
    var parent = $(this)
      .closest("ul")
      .prev()
      .attr("href");
    var hash = $(this).attr("href");
    $(this).attr("href", parent + hash);
  }
});

if (pin) {
  // create a scene
  new ScrollMagic.Scene({
    duration: $main.height(), // the scene should last for a scroll distance of 100px
    offset: 360 // start this scene after scrolling for 50px
  })
    .setPin(pin) // pins the element for the the scene's duration
    .addTo(controller); // assign the scene to the controller
}

const scrollSpy = (event, index, $element) => {
  $(".side-menu li").removeClass("active-by-scroll");
  var elementId = $element.attr("id");
  if (elementId) {
    $(".side-menu a").each(function() {
      var check = $(this)
        .attr("href")
        .indexOf("#" + elementId);
      if (check !== -1) {
        $(this)
          .parent()
          .addClass("active-by-scroll");
      }
    });
  }
};

var scenes = [];

const setClass = function(cssClass) {
  $(".side-menu li").removeClass("active-by-scroll");
  $(".side-menu a").each(function() {
    var check = $(this)
      .attr("href")
      .indexOf("#" + cssClass);
    if (check !== -1) {
      $(this)
        .parent()
        .addClass("active-by-scroll");
    }
  });
};

const setState = function(event, element) {
  var elementId = element.attr("id");
  if (elementId) {
    if (event.scrollDirection == "FORWARD") {
      scenes.unshift(elementId);
      setClass(scenes[0]);
    }
    if (event.scrollDirection == "REVERSE") {
      scenes.shift();
      setClass(scenes[0]);
    }
  }
};

$(".vc_custom_heading").each(function(index) {
  var $this = $(this);
  console.log($this.outerHeight());
  var id = $(this).attr("id");
  var headingScene = new ScrollMagic.Scene({
    offset: $this.outerHeight() * -0.5,
    triggerHook: 0.15,
    triggerElement: $this[0]
  })
    .addTo(controller)
    .on("enter", function(event) {
      setState(event, $this);
    })
    .on("leave", function(event) {
      setState(event, $this);
    });
});
